import React from 'react'

function TableLoader({ colspan }) {
  return (
    <tbody>
      <tr>
        <td colSpan={parseInt(colspan)} style={{ textAlign: "center" }}>
          <div className="spinner-border text-primary" role="status"  >
            <span className="visually-hidden">Loading...</span>
          </div>
        </td>
      </tr>
    </tbody>
  )
}

export default TableLoader